import { TECLAS } from '@/lib/softphone/estado';

export function Teclado({ alMarcar }: { alMarcar: (tecla: string) => void }) {
  return (
    <div role="group" aria-label="Teclado de marcado" className="grid grid-cols-3 gap-1.5">
      {TECLAS.map((tecla) => (
        <button
          key={tecla}
          type="button"
          aria-label={`Marcar ${tecla}`}
          onClick={() => alMarcar(tecla)}
          className="h-9 rounded-md border border-border text-sm font-medium tabular-nums transition-colors duration-150 ease-out hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {tecla}
        </button>
      ))}
    </div>
  );
}
